const AP_EMBED_TOKEN_KEY = 'ap_embed_token';
const REFRESH_WITHIN_MS = 2 * 60 * 60 * 1000;

export function storeApEmbedToken(token: string): void {
  sessionStorage.setItem(AP_EMBED_TOKEN_KEY, token);
}

export function getStoredApEmbedToken(): string | null {
  return sessionStorage.getItem(AP_EMBED_TOKEN_KEY);
}

export function getApTokenExpiresAt(token: string): number | null {
  try {
    const payloadPart = token.split('.')[1];
    if (!payloadPart) return null;
    const base64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64)) as { exp?: number };
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function shouldRefreshApEmbedToken(token: string | null, withinMs = REFRESH_WITHIN_MS): boolean {
  if (!token) return true;
  const expiresAt = getApTokenExpiresAt(token);
  if (expiresAt == null) return true;
  return expiresAt - Date.now() <= withinMs;
}
